import React, { useState, useEffect, useCallback } from 'react';
import './Modal.css';

const ImageGallery = ({ images, initialIndex = 0, title = "Images", onIndexChange }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(initialIndex);
    const handlePrevImage = useCallback(() => {
        if (images.length > 1) {
            const newIndex = currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1;
            setCurrentImageIndex(newIndex);
            onIndexChange?.(newIndex);
        }
    }, [images.length, currentImageIndex, onIndexChange]);

    const handleNextImage = useCallback(() => {
        if (images.length > 1) {
            const newIndex = currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1;
            setCurrentImageIndex(newIndex);
            onIndexChange?.(newIndex);
        }
    }, [images.length, currentImageIndex, onIndexChange]);

    // Keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft') {
                handlePrevImage();
            } else if (e.key === 'ArrowRight') {
                handleNextImage();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [images.length, handleNextImage, handlePrevImage]);

    if (!images || images.length === 0) {
        return <div>No images available</div>;
    }

    return (
        <div className="image-gallery-container">
            <img
                src={images[currentImageIndex]}
                alt={`Image ${currentImageIndex + 1}`}
                className="gallery-image"
            />
            {images.length > 1 && (
                <>
                    <button
                        className="nav-button nav-prev"
                        onClick={handlePrevImage}
                        aria-label="Previous image"
                    >
                        ‹
                    </button>
                    <button
                        className="nav-button nav-next"
                        onClick={handleNextImage}
                        aria-label="Next image"
                    >
                        ›
                    </button>
                    <div className="image-dots">
                        {images.map((_, index) => (
                            <button
                                key={index}
                                className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                                onClick={() => {
                                    setCurrentImageIndex(index);
                                    onIndexChange?.(index);
                                }}
                                aria-label={`Go to image ${index + 1}`}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default ImageGallery;
